export default "__VITE_ASSET__Bvv$mIl5__"